import { useMutation } from "@tanstack/react-query";
import * as req from "@script/req";
import type { RosterResponse } from "@/types/snapshot-type";
import { toast } from "@/components/toast/CustomToast";

export default function useSaveRosterMutation() {
  return useMutation({
    mutationFn: (variables: {
      data: {
        year: number;
        month: number;
        roster: RosterResponse["roster"];
        schedule_id: string;
        memo: string;
      };
      group_id?: string;
    }) => req.saveRoster(variables.data, variables.group_id),
    onSuccess: () => {
      toast.success("변경사항이 성공적으로 저장되었습니다.");
    },
    onError: (error) => {
      console.error("저장 실패:", error);
      if (error instanceof Error) {
        alert(`저장 실패: ${error.message}`);
      }
    },
  });
}
